import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Lots_ds_check_inventory_existsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotIds?: number[], vendorLotIds?: number[] }): 
  Promise<{ result: { LotId?: number, Lot?: { VendorLotId?: number } }[] }> 
  {
    let url = `${environment.backendUrl}api/Lots/datasources/ds_check_inventory_exists/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotIds?: number[], vendorLotIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { LotId?: number, Lot?: { VendorLotId?: number } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Lots/datasources/ds_check_inventory_exists/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotIds?: number[], vendorLotIds?: number[], $keys: { LotId?: number, Lot?: { VendorLotId?: number } }[] }): 
  Promise<{ result: { LotId?: number, Lot?: { VendorLotId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_check_inventory_exists/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
